<template lang='pug'>
v-container(fluid class="pa-0")
  v-app-bar(app, flat, dense, fixed)
    v-app-bar-nav-icon(@click='toggleDrawerMenu')
    v-toolbar-title(class='subtitle-1') 休暇承認
  v-container(fluid)
    v-row(align='center', justify='center')
      v-list-group(v-for="(itemDate, indexDate) in approveList", :key="itemDate.startedDate", :class="{'offrow':itemDate.calendar != null && itemDate.isOffDay == true}")
        template(v-slot:activator)
          v-row(:class="{}")
            span(class='date-title pr-3') {{itemDate.displayName}}
            span(class='date-total pr-3') 申請日時:{{itemDate.posted}}
            span(class='date-total pr-3') ステータス:{{itemDate.status}}
            span(class='date-total pr-3') 区分:{{itemDate.workTypeName}}
            span(class='date-total pr-3') 対象日:{{itemDate.dateDisp}}
            v-btn(@click="approve(itemDate)") 承認する
            v-btn(@click="change(itemDate)") 変更する
            v-btn(@click="discussion(itemDate)") 調整状態にする
            span(class='date-title pl-2', v-if="itemDate.calendar != null && itemDate.dayComment != null && itemDate.dayComment != ''") {{itemDate.dayComment}}
        v-row(v-for="(item, index) in itemDate.approvals", :key="item.statusMessageId", class='status-message-row')
          span {{item.posted}} {{item.status}} [{{item.workTypeName}}] {{item.changedDisplayName}} {{item.changedComment}}
    v-dialog(v-model='dialogWorkType', max-width='400')
      v-card
        v-card-title Koos Workspace
        v-card-text {{requestMethod}}します。コメントを記入お願いします。 
        v-card-text(v-if='requestMethod=="変更"')
          v-card(min-width='100', width='100', flat, class='timecell ml-2')
            v-select(:items='workTypesByOffDay(requestParam.isOffDay)', item-text="name", item-value='tenantWorkTypeId', v-model='requestParam.tenantWorkTypeIdAM', dense, width='80', label='午前')
          v-card(min-width='100', width='100', flat, class='timecell ml-2')
            v-select(:items='workTypesByOffDay(requestParam.isOffDay)', item-text="name", item-value='tenantWorkTypeId', v-model='requestParam.tenantWorkTypeIdPM', dense, width='80', label='午後')
        v-card-text
          v-text-field(v-model='requestParam.comment', label='コメント') 
        v-card-actions
          v-spacer
          v-btn(text, @click='cancelRequest') キャンセル
          v-btn(text, @click='confirmRequest', :disabled='inProcess') OK
</template>

<script>
import basic from '@/components/mixins/basic'
import moment from "moment-timezone";
moment.locale('ja')

export default {
  mixins: [basic],
  components: {
  },
  computed: {
  },
  data() {
    return {
      approveList:[],
      workTypes: [],
      dialogWorkType: false,
      requestParam: {},
      requestSuccessMessage: null,
      requestMethod:'',
      inProcess: false,
    }
  },
  mounted() {
  },
  methods: {
    async masterReady () {
      if (!this.$store.getters['Login/isAdmin']) {
        // redirect to home when you are not admin
        this.$router.push(this.site.deployFolder + "/")
      }
      this.workTypes = await this.$store.dispatch('Calendar/getWorkTypes')
      await this.search()
    },
    async search () {
      this.approveList = await this.$store.dispatch('Calendar/listToApprove')
    },
    workTypesByOffDay (isOffDay) {
      if (isOffDay) {
        return this.workTypes.filter(element => {
          return element.canUseInOffDay
        })
      }else{
        return this.workTypes.filter(element => {
          return element.canUseInWorkDay
        })
      }
    },
    async approve(item) {
        this.requestParam = { personalCalendarId:item.personalCalendarId, param: 'approval', value: '', comment: '' }
        this.requestMethod = '承認'
        this.requestSuccessMessage = '勤務変更を承認しました'
        this.dialogWorkType = true;
    },
    async discussion (item) {
        this.requestParam = { personalCalendarId:item.personalCalendarId, param: 'discussion', value: '', comment: '' }
        this.requestMethod = '調整状態に'
        this.requestSuccessMessage = '勤務変更を調整に変更しました。調整が終わったら、承認するか、変更してください。'
        this.dialogWorkType = true
    },
    async change (item) {
      this.requestParam = { personalCalendarId:item.personalCalendarId, param: 'change', value: '', comment: '', plan: item.plan, tenantWorkTypeIdAM: item.tenantWorkTypeIdAM, tenantWorkTypeIdPM: item.tenantWorkTypeIdPM, isOffDay:item.isOffDay }
      this.requestMethod = '変更'
      this.requestSuccessMessage = '勤務変更を変更しました。必要でしたら、メンバーにもお伝えください。'
      this.dialogWorkType = true
    },
    async cancelRequest() {
      this.dialogWorkType = false;
      this.search()
    },
    async confirmRequest() {
      if (this.inProcess) { return }
      try {
        this.inProcess = true
        await this.$store.dispatch("Calendar/updatePersonal", this.requestParam); 
        this.dialogWorkType = false;
        this.dispSuccess(this.requestSuccessMessage)
        this.search()
      } catch {
        this.dispError('変更に失敗しました。')
      }
      this.inProcess = false
    },
    toggleDrawerMenu () {
      this.$emit('toggle')
    }
  }
};
</script>

<style scoped lang='scss'>

</style>